import { forwardRef } from 'react';
import { capitalize } from 'lodash';
import PrintableWrapper from '../../components/PrintableWrapper';
import SementesList from './create-edit/resumo/sementes-list';
import AdubosList from './create-edit/resumo/adubos-list';
import PrintFooter from './create-edit/resumo/print-footer';
import { PropsGetRecomendacaoPrint } from './utils';
import { situacaoParse } from '../../utils/constants';

type PrintableProps = {
  data: PropsGetRecomendacaoPrint;
};

const Printable = forwardRef<HTMLDivElement, PrintableProps>(
  ({ data }, ref) => (
    <div className="hidden-container">
      <PrintableWrapper ref={ref}>
        <div className="titulo-print-container">
          <h2 className="pl-2">{`Recomendação de Semeadura ${
            data.id || ''
          }`}</h2>
          <h4 className="pr-4">{data.dataHoraImpressao}</h4>
        </div>
        <span className="pl-2 text-large">
          <strong>Situação: </strong>
          {`${data.situacao ? situacaoParse[data.situacao].label : ''}`}
        </span>
        <span className="pl-2 text-large">
          <strong>Status: </strong>
          {capitalize(data.status)}
        </span>
        <SementesList formValues={data} striped={false} printable />
        <AdubosList formValues={data} hideOrderIcon striped={false} />
        <PrintFooter
          atividade={data.atividade?.descricao}
          propriedade={data.propriedadeDescricao}
          safra={data.safra?.descricao}
          userRecomendante={data.recomendante}
        />
      </PrintableWrapper>
    </div>
  ),
);

Printable.displayName = 'Printable';

export default Printable;
